"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const lodash_1 = require("lodash");
const mobx_react_1 = require("mobx-react");
const MLCThemeProvider = (props) => {
    const { uiStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { children } = props;
    const setWindowSize = () => {
        const sizeData = {
            width: window.innerWidth,
            height: window.innerHeight,
        };
        uiStore.setWindowSize(sizeData);
    };
    (0, react_1.useEffect)(() => {
        setWindowSize();
        window.addEventListener('resize', (0, lodash_1.debounce)(setWindowSize, 200));
    }, []);
    return react_1.default.createElement("div", { className: `theme--${uiStore.currentTheme}` }, children);
};
exports.default = (0, mobx_react_1.observer)(MLCThemeProvider);
